export const LabelStatus = ({ value }) => {
  return (
    <span className={`station-status ${!value ? "off" : ""}`}>{value ? 'ONLINE': 'OFFLINE'}</span>
  )
}
